export default "__VITE_ASSET__a38cca05__"